<template>
    <span 
        id="example" 
        :style="{color: rowData.color, backgroundColor: rowData.background_color, fontSize: '1.25rem'}"
        class="label"
        @click.prevent="toggleDetailRow">
        {{ rowData.name }}
    </span>
</template>

<script>
export default {
    name: 'SourceLabel',

    props: {
        rowData:  {
            type:     Object,
            required: true
        },
        rowIndex: {
            type:    Number,
            default: 0
        }
    },

    methods: {
        toggleDetailRow() {
            let index = this.$parent.visibleDetailRows.indexOf(this.rowData.id);
            if (index > -1) {
                this.$parent.visibleDetailRows.splice(index, 1);
            } else {
                this.$parent.visibleDetailRows.push(this.rowData.id);
            }
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Sources/SourceLabel.vue